import { React, useState, useEffect } from "react";
import { Button, Icon, Checkbox } from "semantic-ui-react";
import { get, isEmpty, omit, map, uniq } from "lodash";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import { transferChat } from "@Redux/Actions/chats";
import { displayNotification } from "@Redux/Actions/notifications";

// Components
import IkTable from "@Components/IkTable";
import IKModal from "@Components/IkModal";
// Utils
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const Transfer = ({ chatCurrent, onClose, dispatch, buttonLabel, userId, search, selectedChats, onTransferSuccess }) => {
	const defaultParamsUsers = {
		page: 1,
		rows: 15,
		orderKey: "user.fullName",
		orderDir: "asc",
		fields: "userId,user.fullName,user.nickName,user.email,user.phone,state",
		state: "En Línea",
	};
	const [filteredItemsUser, setFilteredItemsUser] = useState([]);
	const [filteredItemsGroups, setFilteredItemsGroups] = useState([]);
	const [filteredItemsCountsUser, setFilteredItemsCountsUser] = useState(1);
	const [filteredItemsCountsGroups, setFilteredItemsCountsGroups] = useState(1);
	const [deselectedUser, setDeselectedUser] = useState({});
	const [deselectedGroups, setDeselectedGroups] = useState({});
	const [stateHeader, setStateHeader] = useState("user");
	const [showOnlyOnline, setShowOnlyOnline] = useState(true);
	const [selected, setSelected] = useState({});
	// const [lastParams, setLasParams] = useState({});
	const [currentParams, setCurremsParams] = useState(defaultParamsUsers);
	const [keepUser, setKeepUser] = useState(false);
	const [keepGroup, setKeepGroup] = useState(true);

	const getDefaultParamsGroups = () => {
		const params = {
			page: 1,
			rows: 15,
			orderKey: "name",
			orderDir: "asc",
			fields: "id,name,type.name",
		};
		if (!isEmpty(search)) {
			params.all = search;
		}
		return params;
	};

	useEffect(() => {
		(async () => {
			const [groupsResponse, usersResponse] = await Promise.all([
				dataHandler({
					dispatch,
					url: "groups",
					params: getDefaultParamsGroups(),
				}),
				dataHandler({
					dispatch,
					url: "/companyUsers/transfer",
					params: currentParams,
				}),
			]);

			setFilteredItemsUser(usersResponse.items);
			setFilteredItemsCountsUser(usersResponse.count);
			setFilteredItemsGroups(groupsResponse.items);
			setFilteredItemsCountsGroups(groupsResponse.count);
		})();
	}, []);

	// save handlers
	const onTransfer = async () => {
		const selectedUser = stateHeader === "user" ? get(selected, "userId", null) : null;
		const selectedGroup = stateHeader === "group" ? get(selected, "id", null) : null;

		if (!selectedUser && !selectedGroup) {
			dispatch(displayNotification({ text: "Debe seleccionar un destino para transferir", isError: true }));
			return;
		}

		if (selectedUser) {
			let isAlreadyAssigned = false;
			if (!isEmpty(selectedChats) && selectedChats.length > 0) {
				isAlreadyAssigned = selectedChats.every((c) => {
					return c.userId === selectedUser;
				});
			} else if (chatCurrent) {
				isAlreadyAssigned = get(chatCurrent, "userId", null) === selectedUser;
			}

			if (isAlreadyAssigned) {
				dispatch(
					displayNotification({ text: "Este usuario ya está atendiendo la conversación seleccionada.", isError: true, title: "Error" })
				);
				return;
			}
		}

		if (!isEmpty(selectedChats) && selectedChats.length > 0) {
			if (selectedChats.length > 1) {
				const chatIds = uniq(map(selectedChats, "id"));
				await dispatch(transferChat(chatIds, selectedUser, selectedGroup, selectedUser === userId, keepUser, keepGroup, true));
			} else {
				const chatId = selectedChats[0].id;
				await dispatch(transferChat(chatId, selectedUser, selectedGroup, selectedUser === userId, keepUser, keepGroup));
			}
		} else {
			const chatId = get(chatCurrent, "id", null);
			if (chatId) {
				await dispatch(transferChat(chatId, selectedUser, selectedGroup, selectedUser === userId, keepUser, keepGroup));
			}
		}

		if (onTransferSuccess) {
			onTransferSuccess();
		}
		onClose();
	};

	// Table Handlers
	const handlerDataUser = async (params) => {
		// setLasParams(omit(params, ["state"]));
		const finalParams = {
			...currentParams,
			...params,
			...(isEmpty(search) ? {} : { all: search }),
		};
		if (!showOnlyOnline && finalParams.state) {
			delete finalParams.state;
		}
		if (showOnlyOnline) {
			finalParams.state = "En Línea";
		}
		const data = await dataHandler({ dispatch, url: "/companyUsers/transfer", params: finalParams });
		setFilteredItemsUser(data.items);
		setFilteredItemsCountsUser(data.count);
	};

	const handlerDataGroup = async (params) => {
		const finalParams = {
			...getDefaultParamsGroups(),
			...params,
			...(isEmpty(search) ? {} : { all: search }),
		};
		const data = await dataHandler({ dispatch, url: "groups", params: finalParams });
		setFilteredItemsGroups(data.items);
		setFilteredItemsCountsGroups(data.count);
	};

	const handleButtomUser = (name, item) => {
		switch (name) {
			case "Watch":
				onTransfer(item);
				break;
			case "onClick":
				setSelected(item);
				setDeselectedGroups(!deselectedGroups);
				break;
			default:
				break;
		}
	};

	const handleButtomGroups = (name, item) => {
		switch (name) {
			case "Watch":
				onTransfer(item);
				break;
			case "onClick":
				setSelected(item);
				setDeselectedUser(!deselectedUser);
				break;
			default:
				break;
		}
	};

	const handleStateHeader = async (state) => {
		setStateHeader(state);
		if (state === "user") {
			const data = await dataHandler({ dispatch, url: "/companyUsers/transfer", params: currentParams });
			setFilteredItemsUser(data.items);
			setFilteredItemsCountsUser(data.count);
		} else {
			const data = await dataHandler({ dispatch, url: "groups", params: getDefaultParamsGroups() });
			setFilteredItemsGroups(data.items);
			setFilteredItemsCountsGroups(data.count);
		}
	};

	const handleShowOnlyOnlineChange = async (e, { checked }) => {
		let omitCurrentParams = omit(currentParams, ["state"]);
		omitCurrentParams.page = 1;
		if (checked) {
			omitCurrentParams = { ...omitCurrentParams, state: "En Línea" };
		}
		const dataUser = await dataHandler({
			dispatch,
			url: "/companyUsers/transfer",
			params: omitCurrentParams,
		});
		setCurremsParams(omitCurrentParams);
		setFilteredItemsUser(dataUser.items);
		setFilteredItemsCountsUser(dataUser.count);
		setShowOnlyOnline(checked);
	};

	const handleRefresh = async () => {
		if (stateHeader === "user") {
			const data = await dataHandler({ dispatch, url: "/companyUsers/transfer", params: currentParams });
			setFilteredItemsUser(data.items);
			setFilteredItemsCountsUser(data.count);
		} else {
			const data = await dataHandler({ dispatch, url: "groups", params: getDefaultParamsGroups() });
			setFilteredItemsGroups(data.items);
			setFilteredItemsCountsGroups(data.count);
		}
	};

	return (
		<IKModal
			title="Transferir Conversación"
			onClose={onClose}
			onSuccess={onTransfer}
			fullHeight
			// className={styles.transferModal}
			saveLabel={buttonLabel || "Transferir"}>
			<div className={styles.grid}>
				<div className={styles.divHeaderNav}>
					<Button
						className={stateHeader === "user" ? `${styles.navButton} ${styles.active}` : styles.navButton}
						onClick={() => {
							handleStateHeader("user");
						}}>
						<Icon className={styles.icon} name="user" />
						Usuarios
					</Button>
					<Button
						className={stateHeader === "group" ? `${styles.navButton} ${styles.active}` : styles.navButton}
						onClick={() => {
							handleStateHeader("group");
						}}>
						<Icon className={styles.icon} name="group" />
						Grupo
					</Button>
					<div className={styles.divHeaderNavRight}>
						<Button icon className={styles.refreshButton} onClick={handleRefresh} title="Refrescar">
							<Icon name="refresh" className={styles.refreshIcon} />
						</Button>
					</div>
				</div>

				{stateHeader === "user" && (
					<div className={styles.tableContainer}>
						<IkTable
							data={filteredItemsUser}
							columns={[
								{ label: "ID", key: "userId", format: "string", dataPosition: "left", width: 1 },
								{ label: "Estado", key: "state", format: "string", dataPosition: "left", width: 1 },
								{ label: "Nombre", key: "user.fullName", dataPosition: "left", format: "string", width: 3 },
								{ label: "Usuario", key: "user.nickName", format: "string", headerPosition: "left", width: 5 },
							]}
							handlerTable={handleButtomUser}
							totalRows={filteredItemsCountsUser}
							defaultParams={currentParams}
							onChangeDeselect={deselectedUser}
							mobileCardView
							cardLine1={[
								{ key: "userId", label: "ID" },
								{ key: "user.fullName", label: "" },
							]}
							cardLine2={["user.phone"]}
							searcher={{
								searchString: search,
								searchable: true,
								searchPosition: "flex-end",
								searchDisabled: false,
								filterButton: false,
								width: "30rem",
							}}
							topButtons={[
								{
									componentType: "custom",
									content: (
										<Checkbox
											checked={keepGroup}
											onChange={(_, { checked }) => {
												return setKeepGroup(checked);
											}}
											label="Mantener grupo"
											className={styles.classCheck}
										/>
									),
								},
								{
									componentType: "custom",
									content: (
										<Checkbox
											checked={showOnlyOnline}
											onChange={handleShowOnlyOnlineChange}
											label="Usuarios en Línea"
											className={styles.classCheck}
										/>
									),
								},
							]}
							topPlaceClassName={styles.topPlaceWrap}
							dataHandler={handlerDataUser}
						/>
					</div>
				)}
				{stateHeader === "group" && (
					<div className={styles.tableContainer}>
						<IkTable
							data={filteredItemsGroups}
							columns={[
								{ label: "ID", key: "id", format: "string", dataPosition: "left", width: 1 },
								{ label: "Grupo", key: "name", format: "string", width: 3 },
								{ label: "Tipos", key: "type.name", format: "string", headerPosition: "left", width: 7 },
							]}
							onChangeDeselect={deselectedGroups}
							handlerTable={handleButtomGroups}
							totalRows={filteredItemsCountsGroups}
							defaultParams={getDefaultParamsGroups()}
							dataHandler={handlerDataGroup}
							mobileCardView
							cardLine1={[
								{ key: "id", label: "ID" },
								{ key: "name", label: "" },
							]}
							cardLine2={[{ key: "type.name", label: "Tipo" }]}
							searcher={{
								searchString: search,
								searchable: true,
								searchPosition: "flex-start",
								searchDisabled: false,
								filterButton: false,
								width: "30rem",
							}}
							topButtons={[
								{
									componentType: "custom",
									content: (
										<Checkbox
											checked={keepUser}
											onChange={(_, { checked }) => {
												return setKeepUser(checked);
											}}
											label="Mantener usuario"
											className={styles.classCheck}
										/>
									),
								},
							]}
							topPlaceClassName={styles.topPlaceWrap}
						/>
					</div>
				)}
			</div>
		</IKModal>
	);
};

Transfer.propTypes = {
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	chatCurrent: PropTypes.object,
	buttonLabel: PropTypes.string,
	userId: PropTypes.number,
	search: PropTypes.string,
	selectedChats: PropTypes.array,
	onTransferSuccess: PropTypes.func,
};

function mapStateToProps({ user }) {
	return {
		userId: user.userId,
	};
}

export default connect(mapStateToProps)(Transfer);
